import { isCustomizedType, reduce } from "et3-type-guards";

import i18nServerResponse from "../../constants/i18n-server-response";
import { getDateAsObject } from "../../core/et3-date";
import { post } from "../axios-post";
import { TAlertData, TOnCallTeamMembersArray } from "../../Types";

export const apiCallGetDashboardData = async () => {
  const { status, data, et3Error } = await post<{
    approvalDataCount: number;
    reportsCount: number;
    reportedCount: number;
    investigationCasesCount: number;
    activeTime: number;
    alertsData: TAlertData;
    team: TOnCallTeamMembersArray;
  }>(`dashboard/getDashboardUpdate`, {
    date: getDateAsObject(new Date())
  });

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    const approvalDataCount = reduce(() => data.approvalDataCount, 0);
    const reportsCount = reduce(() => data.reportsCount, 0);
    const reportedCount = reduce(() => data.reportedCount, 0);
    const investigationCasesCount = reduce(
      () => data.investigationCasesCount,
      0
    );
    const activeTime = reduce(() => data.activeTime, 0);

    const alertsData = reduce(() => data.alertsData, {
      newUsersAlert: false,
      fbUsersAlert: false,
      smsUsersAlert: false,
      emailUsersAlert: false,
      lastLoginUsersAlert: false,
      androidPaymentsAlert: false,
      iosPaymentsAlert: false,
      flaggedConnectionAlert: false,
      flaggedConnectionAppAlert: false,
      flaggedConnectionWebAlert: false,
      flaggedConnectionAdminAlert: false,
      rateLimitBlockedAppAlert: false,
      rateLimitBlockedWebAlert: false,
      rateLimitBlockedAdminAlert: false,
      rateLimitBlockedAlert: false,
      alertDate: 0,
      lastAlarmsCheckDateAlert: false,
      sentEmailsAlert: false,
      unsubscribedUserActivityEmailsAlert: false,
      unsubscribedPromotionalEmailsAlert: false,
      unsubscribedNewMessageEmailsAlert: false,
      unsubscribedVisitProfileEmailsAlert: false,
      unsubscribedLikeEmailsAlert: false,
      ipGeolocationAlert: false,
      bpUserAlert: false,
      alertLogs: {
        SMS_USER_LOG_ISSUE: [],
        EMAIL_USER_LOG_ISSUE: [],
        NEW_USER_LOG_ISSUE: [],
        FB_USER_LOG_ISSUE: [],
        LAST_LOGIN_LOG_ISSUE: [],

        ANDROID_PAYMENTS: [],
        IOS_PAYMENTS: [],
        FLAGGED_CONNECTIONS: [],
        RATE_LIMIT: [],
        EMAIL_SENT: [],
        UNSUBSCRIBED_USER_ACTIVITY_EMAILS: [],
        UNSUBSCRIBED_PROMOTIONAL_EMAILS: [],
        UNSUBSCRIBED_NEW_MESSAGE_EMAILS: [],
        UNSUBSCRIBED_VISIT_PROFILE_EMAILS: [],
        UNSUBSCRIBED_LIKE_EMAILS: []
      }
    });
    const team = reduce(() => data.team, []);
    return {
      data: {
        approvalDataCount,
        reportsCount,
        reportedCount,
        investigationCasesCount,
        activeTime,

        alertsData,
        team
      },
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: {
        approvalDataCount: 0,
        reportsCount: 0,
        reportedCount: 0,
        investigationCasesCount: 0,
        activeTime: 0,

        alertsData: {
          newUsersAlert: false,
          fbUsersAlert: false,
          smsUsersAlert: false,
          emailUsersAlert: false,
          lastLoginUsersAlert: false,
          androidPaymentsAlert: false,
          iosPaymentsAlert: false,
          flaggedConnectionAlert: false,
          flaggedConnectionAppAlert: false,
          flaggedConnectionWebAlert: false,
          flaggedConnectionAdminAlert: false,
          rateLimitBlockedAppAlert: false,
          rateLimitBlockedWebAlert: false,
          rateLimitBlockedAdminAlert: false,

          rateLimitBlockedAlert: false,
          alertDate: 0,
          sentEmailsAlert: false,
          unsubscribedUserActivityEmailsAlert: false,
          unsubscribedPromotionalEmailsAlert: false,
          unsubscribedNewMessageEmailsAlert: false,
          unsubscribedVisitProfileEmailsAlert: false,
          unsubscribedLikeEmailsAlert: false,
          lastAlarmsCheckDateAlert: false,
          ipGeolocationAlert: false,
          bpUserAlert: false,
          alertLogs: {
            SMS_USER_LOG_ISSUE: [],
            EMAIL_USER_LOG_ISSUE: [],
            NEW_USER_LOG_ISSUE: [],
            FB_USER_LOG_ISSUE: [],
            LAST_LOGIN_LOG_ISSUE: [],
            ANDROID_PAYMENTS: [],
            IOS_PAYMENTS: [],
            FLAGGED_CONNECTIONS: [],
            RATE_LIMIT: [],
            EMAIL_SENT: [],
            UNSUBSCRIBED_USER_ACTIVITY_EMAILS: [],
            UNSUBSCRIBED_PROMOTIONAL_EMAILS: [],
            UNSUBSCRIBED_NEW_MESSAGE_EMAILS: [],
            UNSUBSCRIBED_VISIT_PROFILE_EMAILS: [],
            UNSUBSCRIBED_LIKE_EMAILS: []
          }
        },
        team: []
      },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: {
        approvalDataCount: 0,
        reportsCount: 0,
        reportedCount: 0,
        investigationCasesCount: 0,
        activeTime: 0,

        alertsData: {
          newUsersAlert: false,
          fbUsersAlert: false,
          smsUsersAlert: false,
          emailUsersAlert: false,
          lastLoginUsersAlert: false,
          androidPaymentsAlert: false,
          iosPaymentsAlert: false,
          flaggedConnectionAlert: false,
          flaggedConnectionAppAlert: false,
          flaggedConnectionWebAlert: false,
          flaggedConnectionAdminAlert: false,
          rateLimitBlockedAlert: false,
          rateLimitBlockedAppAlert: false,
          rateLimitBlockedWebAlert: false,
          rateLimitBlockedAdminAlert: false,
          alertDate: 0,
          lastAlarmsCheckDateAlert: false,
          sentEmailsAlert: false,
          unsubscribedUserActivityEmailsAlert: false,
          unsubscribedPromotionalEmailsAlert: false,
          unsubscribedNewMessageEmailsAlert: false,
          unsubscribedVisitProfileEmailsAlert: false,
          unsubscribedLikeEmailsAlert: false,
          ipGeolocationAlert: false,
          bpUserAlert: false,
          alertLogs: {
            SMS_USER_LOG_ISSUE: [],
            EMAIL_USER_LOG_ISSUE: [],
            NEW_USER_LOG_ISSUE: [],
            FB_USER_LOG_ISSUE: [],
            LAST_LOGIN_LOG_ISSUE: [],
            ANDROID_PAYMENTS: [],
            IOS_PAYMENTS: [],
            FLAGGED_CONNECTIONS: [],
            RATE_LIMIT: [],
            EMAIL_SENT: [],
            UNSUBSCRIBED_USER_ACTIVITY_EMAILS: [],
            UNSUBSCRIBED_PROMOTIONAL_EMAILS: [],
            UNSUBSCRIBED_NEW_MESSAGE_EMAILS: [],
            UNSUBSCRIBED_VISIT_PROFILE_EMAILS: [],
            UNSUBSCRIBED_LIKE_EMAILS: []
          }
        },
        team: []
      },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
